var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-index"},[(!_vm.screen)?[_c('layout-nav',{staticClass:"layout-nav"}),_c('LayoutMain',{staticClass:"layout-main",style:(_vm.layoutMainHeight)})]:_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }